import React from "react";
import Tray from '~/modules/Tray/Video';

const YouMayLikeTray = props => {
  const trayProps = {
    noBlockTitle: true,
    data: {
      title: `YOU MAY LIKE`,
      contentData: props.data,
      settings: {
        seeAll: true,
        seeAllPermalink: "/conceptLandingPage"
      }
    },
    layout: {
      settings: {
        loop: false,
        infoHover: false,
        thumbnailType: "portrait",
        aspectRatio: 178,
        columns: {
          desktop: 10,
          mobile: 3,
          tablet: 7,
          ott: 10
        }
      }
    }
  };
  return (
    <div className="netflix-tray">
      <Tray
        {...trayProps}
        showCount={false}
        netflix={true}
        hideCategories={true}
        neouTrayTitle={true}
      />
    </div>
  );
};

export default YouMayLikeTray;
